"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerGlobalValue = exports.cache = void 0;
exports.cache = {};
/**
 * 创建一个唯一的函数名（在当前页面会话中保障其唯一性即可）。
 * @param extra 可以额外自定义部分字符串。
 * @returns
 */
function registerGlobalValue(scheme, callback, once) {
    var _a;
    if (once === void 0) { once = true; }
    if (!exports.cache[scheme]) {
        var uuid = '$jsBridgeFn_' +
            Date.now().toString(16).toUpperCase() +
            '_' +
            Math.ceil(Math.random() * 10000)
                .toString(16)
                .toUpperCase();
        exports.cache[scheme] = {
            uuid: uuid,
            queue: [{ once: once, callback: callback }],
        };
    }
    else {
        exports.cache[scheme].queue.push({ once: once, callback: callback });
    }
    Object.assign(window, (_a = {},
        _a[exports.cache[scheme].uuid] = function (data) {
            exports.cache[scheme].queue = exports.cache[scheme].queue.reduce(function (accu, curr) {
                var once = curr.once, callback = curr.callback;
                if (!once) {
                    accu.push(curr);
                }
                callback(data);
                return accu;
            }, []);
        },
        _a));
    return exports.cache[scheme].uuid;
}
exports.registerGlobalValue = registerGlobalValue;
//# sourceMappingURL=registerGlobalValue.js.map